<script>
    import { createEventDispatcher, onMount } from 'svelte'
    import { menuItems } from '../menu.js'
    import { Mediator } from '../lib/mediator.js'
    import { uuid } from '../lib/utils.js'
    const dispatch = createEventDispatcher()

    export let open = false
    import TreeView from '../lib/TreeView.svelte'
    import { push } from 'svelte-spa-router';

    let id = uuid()

    let tree = {}
    let departmentTree = {}


    function menuClick(e) {
        dispatch('selected')
    }

    function homeClick(e) {
        let href = ''
        try {
            href = '#/noDashboard'
            push('/noDashboard')
            Mediator.publish('routing', { Message: '/', From: 'TreeView' })
        } catch (e) {}
        dispatch('selected')
    }

    async function loadMenu() {
        tree = await menuItems()
    }


    onMount(() => {
            push('/home')
    })

</script>

{#if open}
    <div class="overlay active"></div>
    <dialog
        class="left scroll "
        class:active={open}
        id="dialog-navigation-drawer"
        open={open}
    >
    
        <header class="fixed">
            <nav>
                <div class="max padding"><strong>Lineages of the Sun</strong></div>
                <div><button on:click={() => {open = false}} class="transparent circle large" data-ui="#dialog-navigation-drawer"><i>close</i></button></div>
            </nav>
        </header>
        
        <ul class="list">
            <li class="wave round"><i>inbox</i><span class="max">Inbox</span><b>24</b></li>
            <li class="wave round"><i>send</i><span>Outbox</span></li>
            <li class="wave round"><i>favorite</i><span>favorities</span></li>
            <li class="wave round"><i>delete</i><span>Trash</span></li>
            <li class="wave round"><i>fiber_manual_record</i><span>Label</span></li>
            <li class="wave round"><i>change_history</i><span>Label</span></li>
            <li class="wave round"><i>stop</i><span>Label</span></li>
        </ul>
    </dialog>
{/if}

<!--     

        <details class="left-padding">
            <summary><i class="right-padding small-padding">folder</i><strong>Main Menu</strong></summary>
            
            <details class="left-padding">
                <summary><i class="right-padding small-padding">folder</i><strong>First</strong></summary>
            
                <ul class="list no-space">
                    <li><p class="left-padding"><i class="right-padding small-padding">pivot_table_chart</i>What 1?</p></li>      
                    <li><p class="left-padding"><i class="right-padding small-padding">pivot_table_chart</i>What 3?</p></li>      
                </ul>     
            
                <details class="left-padding">
                    <summary><i class="right-padding small-padding">folder</i><strong>Second</strong></summary>
            
                    <ul class="list no-space">
                        <li><p class="left-padding"><i class="right-padding small-padding">pivot_table_chart</i>What 2?</p></li>      
                    </ul>
            
                    <details class="left-padding">
                        <summary><i class="right-padding small-padding">folder</i><strong>Third</strong></summary>

                        <ul class="list no-space">
                            <li><p class="left-padding">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</p></li>
                        </ul>   

                    </details>
                </details>
            </details>
        </details>

<div
        class="w3-sidebar w3-card w3-animate-left w3-animate-left ddt-sidebar-menu"
        style="display: block; position: fixed; top: 60px; width: 33%;overflow-x:hidden;:scroll;z-index:255;height:90vh;"
        id="mySidebar"
    >
        <button
            class="w3-button w3-block w3-left-align ddt-sidebar-menu ddt-sidebar-menu-hov"
            on:click={homeClick}
            style="cursor:pointer"
            ><span class="ddt-icons material-icons mi">speed</span>
            Dashboard
        </button>



        <TreeView bind:tree={tree} on:selected={menuClick} />

    </div> -->